import React from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Autocomplete,
} from "@mui/material";
import { format } from "date-fns";

const HeaderDriverSalary = ({
  clientId,
  setClientId,
  clients,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  onLoadSalary,
  onConfirm,
  onExport,
  onExportAdmin,
  onClientSearchChange,
  onUpdateTransactions,
  showUpdateButton = false,
}) => {

  // Common styles for inputs to force black color
  const inputStyles = {
    "& .MuiInputBase-input": { color: "black" },
    "& .MuiInputLabel-root": { color: "black" },
    "& .MuiInputLabel-root.Mui-focused": { color: "black" },
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "black" },
      "&:hover fieldset": { borderColor: "black" },
      "&.Mui-focused fieldset": { borderColor: "black" },
    },
    // For Select specific components
    "& .MuiSelect-icon": { color: "black" },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "black" },
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        padding: "15px 20px",
        borderRadius: "8px",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
        color: "black", // Force container text to black
      }}
    >
      {/* Client Selection - Autocomplete for Search */}
      <Autocomplete
        id="client-select"
        options={clients}
        getOptionLabel={(option) =>
          option.company_name || option.name || option.username || "Unknown Client"
        }
        value={clients.find(c => c.user_id === clientId) || null}
        onChange={(event, newValue) => {
          setClientId(newValue ? newValue.user_id : "");
        }}
        onInputChange={(event, newInputValue, reason) => {
          if (onClientSearchChange && (reason === "input" || reason === "clear")) {
            onClientSearchChange(newInputValue);
          }
        }}
        filterOptions={(x) => x}
        sx={{
          minWidth: 200,
          width: 300,
          backgroundColor: "#fff", // Force input background white
          ...inputStyles
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Client"
            size="small"
            InputLabelProps={{
              style: { color: "black" }
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} style={{ color: "black", backgroundColor: "#fff" }}>
            {option.company_name || option.name || option.username || "Unknown Client"}
          </li>
        )}
      />

      {/* From Date */}
      <TextField
        label="From Date"
        type="date"
        size="small"
        value={fromDate ? format(fromDate, "yyyy-MM-dd") : ""}
        onChange={(e) => setFromDate(e.target.value ? new Date(e.target.value + "T00:00:00") : null)}
        InputLabelProps={{
          shrink: true,
          style: { color: "black" } // Force label color
        }}
        sx={{ width: 150, ...inputStyles }}
      />

      {/* To Date */}
      <TextField
        label="To Date"
        type="date"
        size="small"
        value={toDate ? format(toDate, "yyyy-MM-dd") : ""}
        onChange={(e) => setToDate(e.target.value ? new Date(e.target.value + "T00:00:00") : null)}
        InputLabelProps={{
          shrink: true,
          style: { color: "black" } // Force label color
        }}
        sx={{ width: 150, ...inputStyles }}
      />

      {/* Load Salary Button - Blue Color */}
      <Button
        variant="contained"
        onClick={onLoadSalary}
        sx={{
          backgroundColor: "#1d82f5",
          "&:hover": { backgroundColor: "#1565c0" },
          height: "40px",
          textTransform: "none",
        }}
      >
        Load Salary
      </Button>

      {/* Export Button - Green Color */}
      <Button
        variant="contained"
        onClick={onExport}
        sx={{
          backgroundColor: "#2e7d32",
          "&:hover": { backgroundColor: "#1b5e20" },
          height: "40px",
          textTransform: "none",
          marginLeft: "10px",
        }}
      >
        Export to Excel
      </Button>

      {/* Admin Export Button - Dark Teal, includes deposit/hold columns */}
      {onExportAdmin && (
        <Button
          variant="contained"
          onClick={onExportAdmin}
          sx={{
            backgroundColor: "#00695c",
            "&:hover": { backgroundColor: "#004d40" },
            height: "40px",
            textTransform: "none",
            marginLeft: "10px",
          }}
        >
          Export Excel (Admin)
        </Button>
      )}

      {/* Spacer to push Confirmation to the end */}
      <Box sx={{ flexGrow: 1 }} />

      {/* Confirmation Button */}
      <Button
        variant="contained"
        onClick={onConfirm}
        sx={{
          backgroundColor: "#ff9800",
          "&:hover": { backgroundColor: "#f57c00" },
          height: "40px",
          textTransform: "none",
        }}
      >
        Confirmation
      </Button>

      {/* Update Salary Transactions Button - Purple Color */}
      {showUpdateButton && (
        <Button
          variant="contained"
          onClick={onUpdateTransactions}
          sx={{
            backgroundColor: "#9c27b0",
            "&:hover": { backgroundColor: "#7b1fa2" },
            height: "40px",
            textTransform: "none",
            marginLeft: "10px",
          }}
        >
          Update Salary Transactions
        </Button>
      )}
    </Box>
  );
};

export default HeaderDriverSalary;
